import { render, staticRenderFns } from "./MarkAsDuplicateModal.vue?vue&type=template&id=bef0806a&scoped=true&"
import script from "./MarkAsDuplicateModal.vue?vue&type=script&lang=js&"
export * from "./MarkAsDuplicateModal.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsDuplicateModal.vue?vue&type=style&index=0&id=bef0806a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0806a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VChip,VRadio,VRadioGroup,VTextField})
